<template>
  <div class="page-learn-ability-test">
    <div class="page-learn-ability-test-block"
         v-for="(block, blockIndex) in list"
         :key="blockIndex"
    >
      <div v-if="blockIndex === currIndex"
           class="page-learn-ability-test-block-container"
      >
        <test-header :number="currIndex + 1"
                     :title="block.blockTitle"
        />
        <div class="page-learn-ability-test-list">
          <div class="page-learn-ability-test-list-item"
               :class="{ 'active': item.selected }"
               v-for="(item, index) in block.list"
               :key="index"
               @click="handleClickItem(blockIndex, item.title)"
          >
            <img v-if="item.selected"
                 :src="require('@/pages/2020/LearnAbilityTest/assets/img/selected_active.png')"
                 alt=""
            />
            <img v-else
                 :src="require('@/pages/2020/LearnAbilityTest/assets/img/selected.png')"
                 alt=""
            />
            {{ item.title }}
          </div>
        </div>
        <div v-if="blockIndex !== 5"
             class="page-learn-ability-test-block-next-btn"
             @click="handleToNextBlock(blockIndex)"
             v-ym-report:MARKETING_LEARNABILITYTEST_NEXT_CLICK="{ step: currIndex + 1 }"
        >
          下一领域
          <img :src="require('@/pages/2020/LearnAbilityTest/assets/img/block_arrow.png')"
               alt=""
          />
        </div>
        <div v-if="blockIndex === 5"
             class="page-learn-ability-test-block-submit-btn"
             @click="handleToNextBlock(blockIndex)"
             v-ym-report:MARKETING_LEARNABILITYTEST_FINISH_CLICK=""
        >
          完成并提交
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from '@/pages/2020/LearnAbilityTest/components/TestPageHeader';

  export default {
    name: 'LearnAbilityTestTestPage',
    components: {
      'test-header': Header,
    },
    data() {
      return {
        currIndex: 0,
        value: [],

        list: [
          {
            blockTitle: '认知领域',
            list: [
              {
                title: '有自己阶段性的学习目标',
                selected: false,
              },
              {
                title: '对不了解的问题敢于发问，增进理解',
                selected: false,
              },
              {
                title: '善于利用网络搜索相关信息，解答疑惑',
                selected: false,
              },
              {
                title: '会通过列大纲、笔记、图表等方法来学习',
                selected: false,
              },
              {
                title: '能通过自问自答的形式，检核自己的理解',
                selected: false,
              },
            ],
          },
          {
            blockTitle: '动机情感领域',
            list: [
              {
                title: '能在学习中寻找乐趣，提升学习动力',
                selected: false,
              },
              {
                title: '在现实和网上，有小伙伴相互交流勉励',
                selected: false,
              },
              {
                title: '能通过看见自己的进步，获得自信',
                selected: false,
              },
              {
                title: '当课程压力大时，能有方法稳定自己的情绪',
                selected: false,
              },
              {
                title: '当信心低落时，会进行自我激励',
                selected: false,
              },
            ],
          },
          {
            blockTitle: '任务领域',
            list: [
              {
                title: '会对将要学习的内容做初步了解，再开始学习',
                selected: false,
              },
              {
                title: '会先了解作业内容与答题方式后再着手进行',
                selected: false,
              },
              {
                title: '在考试前会关注考试范围、题型、命题方向等相关信息',
                selected: false,
              },
              {
                title: '能在网上查询相关信息，对课内学习成果做进一步完善',
                selected: false,
              },
              {
                title: '针对不同科目，孩子会根据合理调配，投入不同的精力',
                selected: false,
              },
            ],
          },
          {
            blockTitle: '环境领域',
            list: [
              {
                title: '会自己选择在安静不受干扰的地方学习',
                selected: false,
              },
              {
                title: '能合理使用手机、平板等电子产品，帮助自己更专注学习',
                selected: false,
              },
              {
                title: '学习前会整理自己的桌子，移除会分心的东西',
                selected: false,
              },
              {
                title: '会判断和同学一块学习的好坏，再决定是否一起学习',
                selected: false,
              },
              {
                title: '上课时会发现老师教法对自己成绩和学习态度的影响',
                selected: false,
              },
            ],
          },
          {
            blockTitle: '时间领域',
            list: [
              {
                title: '了解睡眠对学习的重要性，保证有充足睡眠时间',
                selected: false,
              },
              {
                title: '善于利用日程表或进度表，掌握学习进程和作业进度',
                selected: false,
              },
              {
                title: '能观察并记录自己在一天内各时段的学习效率和状态',
                selected: false,
              },
              {
                title: '能保持规律的生活，能做到劳逸结合',
                selected: false,
              },
              {
                title: '临近考试会计划好各个科目的复习进度，并严格执行',
                selected: false,
              },
            ],
          },
          {
            blockTitle: '求助资源领域',
            list: [
              {
                title: '会和朋友分享笔记、参考书籍以及考试信息',
                selected: false,
              },
              {
                title: '善于利用生活中的资源学习，如参考书、图书馆、网络等',
                selected: false,
              },
              {
                title: '主动向老师或同学请教学习问题，不把问题带回家',
                selected: false,
              },
              {
                title: '使用合适的参考书和习题，帮助学习',
                selected: false,
              },
              {
                title: '与同学组成学习小组，互相研讨或温习功课',
                selected: false,
              },
            ],
          },
        ],
      };
    },
    methods: {
      handleClickItem(index, title) {
        this.list[index].list.map((item) => {
          if (item.title === title) {
            item.selected = !item.selected;
          }
          return item;
        });
      },
      async handleSubmit() {
        await this.list.forEach((block) => {
          const arr = block.list.filter(item => item.selected === true);
          this.value.push(arr.length);
        });
        this.$emit('test-result', this.value);
      },
      handleToNextBlock(index) {
        console.log('index', index, 'list', this.list);
        const arr = this.list[index].list.find(item => item.selected === true);
        console.log('arr', arr);
        if (arr) {
          this.currIndex = index + 1;
          if (index === 5) {
            this.handleSubmit();
          }
          return;
        }
        this.$toast('请选择至少一个吧');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-learn-ability-test {
    min-height: 100%;
    background: @color-white;

    &-list {
      margin-top: 100px;
    }

    &-list-item {
      margin-bottom: 78px;
      padding-left: 60px;
      padding-right: 70px;
      display: flex;
      align-items: center;
      color: #666;
      font-size: 32px;

      img {
        margin-right: 18px;
        display: block;
        width: 36px;
        height: 36px;
      }

      &.active {
        color: #222;
        font-weight: 600;
      }
    }

    &-block-next-btn,
    &-block-submit-btn {
      position: fixed;
      right: 40px;
      bottom: 60px;
      width: 300px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #242648;
      font-size: 36px;
      font-weight: bold;
      border-radius: 50px;
      background: linear-gradient(0deg, #ffc800, #ffd600);

      img {
        margin-left: 28px;
        display: block;
        width: 46px;
        height: 40px;
      }
    }

    &-block-submit-btn {
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }

</style>
